import React, {Component} from 'react';
import * as authActions from '../actions/authActions'

import {connect} from 'react-redux'

import Uploader from '../Components/Upload/Uploader'
import Categories from '../Components/Upload/Categories'
import Mapping from '../Components/Upload/Mapping'
import Listing from '../Components/Upload/Listing'

import axios from 'axios'
import Config from '../Helpers/Config';
import {NotificationManager} from '../Helpers/NotificationManager';;

class Upload extends Component {

    constructor(props) {
        super(props);
        this.state = {
            datasets:[],
            step:0,
            selectedCategory:null,
            id:null,
            restarting:false
        };
        this.finish = this.finish.bind(this)
        this.restart = this.restart.bind(this)
    }

    render() {
        return (
           <div>
               {
                   this.state.step === 0 &&
                   <div>
                       <Uploader onUpload={(response) => {
                           this.setState({
                               datasets:response.results,
                               id:response.id,
                               step:this.state.step + 1
                           })
                       }} businessId={this.props.auth.business.id}/>
                       <Listing businessId={this.props.auth.business.id} restarting={this.state.restarting} restart={this.restart}/>
                   </div>
               }
               { this.state.step === 1 && <Categories data={this.state.datasets} onChange={ category => this.setState({
                   selectedCategory:category,
                   step:this.state.step + 1
               }) }/> }
               { this.state.step === 2 && <Mapping
                   onSuccess={(mapping) => this.finish(mapping) }
                   categoryId={this.state.selectedCategory.id}
                   data={this.state.datasets[0]}
                   businessId={this.props.auth.business.id} /> }
           </div>
        );
    }

    finish(mapping){
        this.setState({
            finishing:true
        })
        // mapping is an object
        axios.post(Config.api(`products/bulk-upload/update/${this.state.id}`), {
            mapping:mapping,
            category_id:this.state.selectedCategory.id,
        }, {
            withCredentials: Config.withCredentials()
        }).then((response) => {

            this.setState({
                step:0
            })

        }).catch((error) => {
            if (error.response.status === 401) {
                this.props.requiresReLogin();
            } else {
                if(error.response && error.response.data && error.response.data.message){
                    NotificationManager.error(error.response.data.message);
                }
            }
            this.setState({uploading: false});
        });
    }


    restart(record){
        // mapping is an object
        axios.post(Config.api(`products/bulk-upload/complete/${record.id}`), {}, {
            withCredentials: Config.withCredentials()
        }).then((response) => {
            this.setState({
                step:1,
                id:record.id,
                datasets:response.data.results
            })
        }).catch((error) => {
            if (error.response.status === 401) {
                this.props.requiresReLogin();
            } else {
                if(error.response && error.response.data && error.response.data.message){
                    NotificationManager.error(error.response.data.message);
                }
            }
            this.setState({uploading: false});
        });
    }


    getBlukFiles(){

    }
}


// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth:state.auth
    }
};


// Maps actions to props
const mapDispatchToProps = (dispatch) => ({
    requiresReLogin: ()=>dispatch(authActions.requiresRelogin(true,true))
});


export default connect(mapStateToProps, mapDispatchToProps)(Upload);

